import { NgModule } from "@angular/core";
import { ModalServiceModule } from "src/app/services/modal2.service.module";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from "@angular/common";

import { ModalComponentModule } from "src/app/components/modal/modal.module";
import { StartModalModule } from "./start-modal/start-modal.module";
import { LearningShortcutModalComponentModule } from "./learning-shortcut/learning-shortcut.module";
import { TimePopupModalComponentModule } from "./time-popup/time-popup.module";
import { EndTimeModalComponentModule } from "./end-time/end-time.module";
import { StartReflectionModalModule } from "./start-reflection/start-reflection.module";
import { RecaptchaModalComponentModule } from "./recaptcha/recaptcha.module";
import { SuccessLoginModalComponentModule } from "./success-login/success-login.module";
import { PasswordHelpModalComponentModule } from "./password-help/password-help.module";

@NgModule({
    imports: [
        ModalServiceModule.forRoot(),
        FontAwesomeModule,
        CommonModule,
        
        ModalComponentModule,
        StartModalModule,
        LearningShortcutModalComponentModule,
        TimePopupModalComponentModule,
        EndTimeModalComponentModule,
        StartReflectionModalModule,
        RecaptchaModalComponentModule,
        SuccessLoginModalComponentModule,
        PasswordHelpModalComponentModule
    ]
})
export class V2ModalsModule {}